import { render, staticRenderFns } from "./URL.vue?vue&type=template&id=c95825ce&"
import script from "./URL.vue?vue&type=script&lang=js&"
export * from "./URL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports